import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import LocationList01Actions, { LocationList01Types } from '../Stores/LocationList01/Actions';

const getAppStore = state => state.app;

export function* locationList01FetchLocationList01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(LocationList01Actions.locationList01FetchLocationList01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `location/indexProcess/LOCATION_LIST_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        LocationList01Actions.locationList01FetchLocationList01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LocationList01Actions.locationList01FetchLocationList01Loading(false));
  }
}

export function* locationList01GoToResource({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/locationDetail/update/${hdrId}`));
}

export function* locationList01NewResource() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/locationDetail/create/${app.curSiteFlowId}`));
}

export function* locationList01GoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/LOCATION/${hdrId}/Location`));
}

export const saga = [
  takeLatest(
    LocationList01Types.LOCATION_LIST01_FETCH_LOCATION_LIST01,
    locationList01FetchLocationList01
  ),
  takeLatest(LocationList01Types.LOCATION_LIST01_GO_TO_RESOURCE, locationList01GoToResource),
  takeLatest(LocationList01Types.LOCATION_LIST01_NEW_RESOURCE, locationList01NewResource),
  takeLatest(LocationList01Types.LOCATION_LIST01_GO_TO_AUDIT, locationList01GoToAudit)
];
